import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import { Btn, Field } from "../components/wf";
import { api } from "../lib/api";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(null);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (pw.length < 6) return setErr("Use at least 6 characters");
    if (pw !== confirm) return setErr("Passwords don't match");
    setSaving(true);
    setErr("");
    try {
      setDone((await api("/auth/set-password", { method: "POST", body: { token, password: pw } })).email);
    } catch (e) {
      setErr(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-6">
      <div className="w-full max-w-sm" data-testid="set-password-page">
        <h1 className="mb-6 text-3xl font-extrabold">Set your password</h1>
        {done ? (
          <>
            <p className="text-wf-mute">Password set for {done}. You can sign in now.</p>
            <Link to="/login"><Btn className="mt-6 w-full" data-testid="set-password-login">Go to Sign In</Btn></Link>
          </>
        ) : (
          <>
            <Field label="New Password" type="password" testid="set-password-input" value={pw} onChange={setPw} />
            <Field label="Confirm Password" type="password" testid="set-password-confirm" value={confirm} onChange={setConfirm} />
            {err && <p className="mb-3 text-sm text-wf-err" data-testid="set-password-error">{err}</p>}
            <Btn className="w-full" onClick={save} loading={saving} disabled={!pw || !confirm || !token} data-testid="set-password-submit">Set Password</Btn>
          </>
        )}
      </div>
    </div>
  );
}
